import { render, staticRenderFns } from "./BatchesHistory.vue?vue&type=template&id=25c531e0&"
import script from "./BatchesHistory.vue?vue&type=script&lang=js&"
export * from "./BatchesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports